import React, {Fragment} from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';

import ErrorPage from "./pages/404Error";
import ContactPage from "./pages/contact";
import ServicePage from "./pages/service";
import HomeDefault from "./pages/home/HomeDefault";
import PortfolioDetailsPage from "./pages/portfolio/details";
import JacobPage from "./pages/jacob";
import TagManager from 'react-gtm-module';
import "./provider/i18n";

const tagManagerArgs = {
  gtmId: 'GTM-T4493TBT'
};

TagManager.initialize(tagManagerArgs)

const App = () => {
     return (
              <Fragment>
                     <Router>
                            <Switch>
                                   <Route path={`${process.env.PUBLIC_URL + "/contact"}`}
                                          component={ContactPage}/>
                                   <Route path={`${process.env.PUBLIC_URL + "/about"}`}
                                          component={ServicePage}/>
                                   <Route exact path={`${process.env.PUBLIC_URL + "/jacob"}`}
                                          component={JacobPage}/>
                                   <Route path={`${process.env.PUBLIC_URL + "/portfolio/:slug"}`}
                                          component={PortfolioDetailsPage}/>
                                   <Route exact path={`${process.env.PUBLIC_URL + "/"}`}
                                          component={HomeDefault}/>
                                   <Route exact component={ErrorPage}/>
                            </Switch>
                     </Router>
              </Fragment>
     );
};

export default App;